<template>
  <v-list-tile @click="listTileClicked(product())" class="list-item" ripple>
    <v-list-tile-content>
      <v-list-tile-title>
        <span
          class="list-item__title"
          :class="{'inCart': collected}">
          {{ product().name }}
        </span>
      </v-list-tile-title>
    </v-list-tile-content>

    <v-list-tile-action v-if="shoppingState && type === 'list'">
      <v-icon color="grey darken-1" v-if="collected">check_box</v-icon>
      <v-icon color="grey darken-1" v-else>check_box_outline_blank</v-icon>
    </v-list-tile-action>

    <v-list-tile-action v-if="!shoppingState && type === 'list'" class="draggable">
      <v-icon color="grey darken-1">drag_indicator</v-icon>
    </v-list-tile-action>

    <v-list-tile-action v-if="type === 'category'">
      <v-icon color="grey darken-1" v-if="onList && !$store.getters.getEditMode">check</v-icon>
      <v-icon color="grey darken-1" v-if="!onList && !$store.getters.getEditMode">add</v-icon>
      <v-icon color="grey darken-1" v-if="$store.getters.getEditMode">close</v-icon>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ListItem',
  data () {
    return {
      onList: null
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    collected: {
      type: Boolean
    }
  },
  computed: {
    shoppingState () {
      return this.getShoppingState()
    }
  },
  methods: {
    ...mapGetters({
      getLists: 'getLists',
      getShoppingState: 'getShoppingState',
      getCurrentList: 'getCurrentList'
    }),
    listTileClicked (item) {
      if (this.type === 'list') {
        this.toggleListState(item)
      } else if (this.type === 'category') {
        if (!this.$store.getters.getEditMode) this.toggleProductToList(item.id)
        else this.$store.commit('REMOVE_PRODUCT', item.id)
      }
    },
    toggleListState (item) {
      if (this.shoppingState) {
        this.$store.commit('TOGGLE_ITEM_COLLECTED', item)
      }
    },
    toggleProductToList (itemId) {
      this.onList = !this.onList
      this.$store.dispatch('toggleProductToList', itemId)
    },
    product () {
      const products = this.$store.getters.getProducts
      const product = products.find(product => product.id === this.item.id)
      return product
    }
  },
  mounted () {
    if (this.type === 'category') {
      this.getCurrentList().items.forEach(item => { if (item.id === this.item.id) this.onList = true })
    }
  }
}
</script>

<style scoped lang="scss">
  $white: #fff;
  .list-item {
    background-color: $white;
  }

  .list-item__title {
    position: relative;
    transition: all 0.15s ease-in-out;
  }

  .list-item__title::before {
    content: '';
    height: 2px;
    width: 100%;
    background: #757575;
    position: absolute;
    top: 50%;
    right: 100%;
    transition: all 0.15s ease-in;
  }
  .list-item__title.inCart {
    color: #757575;
  }
  .list-item__title.inCart::before{
    transform: translateX(100%);
    transition: all 0.25s ease-out;
  }

  .deleted {
    /* display: none; */
    /* transform-origin: top center;
    transform: scale(1, 0);
    transition: transform 0.5s ease-in-out; */
  }

  /* .deleted > .list__tile {
    transform: scale(1, 10);
    transition: transform 0.5s ease-in-out;
  } */
</style>



// WEBPACK FOOTER //
// ListItem.vue?a06e129c